import React from 'react'
import '@pages/Dashboard/DashboardSkeleton.css'

export type DashboardSectionCardSkeletonProps = {
  metrics?: number
  metricColumns?: 3 | 4
  block?: 'default' | 'tall' | 'chart' | 'none'
  calendar?: boolean
}

/** In-card placeholder body reused from the former full-page dashboard skeleton. */
function DashboardSectionCardSkeleton({
  metrics = 0,
  metricColumns = 4,
  block = 'default',
  calendar = false,
}: DashboardSectionCardSkeletonProps): React.ReactElement {
  return (
    <div
      className={`dashboard-section-card-skeleton dashboard-skeleton-shimmer${
        calendar ? ' dashboard-section-card-skeleton--calendar' : ''
      }`}
      aria-hidden="true"
    >
      {metrics > 0 ? (
        <div
          className={`dashboard-skeleton-metrics${
            metricColumns === 3 ? ' dashboard-skeleton-metrics--three' : ''
          }`}
        >
          {Array.from({ length: metrics }).map((_, index) => (
            <div key={`metric-${index}`} className="dashboard-skeleton-metric">
              <span className="dashboard-skeleton-metric-label" />
              <span className="dashboard-skeleton-metric-value" />
            </div>
          ))}
        </div>
      ) : null}
      {block !== 'none' ? (
        <span
          className={`dashboard-skeleton-block${
            block === 'tall'
              ? ' dashboard-skeleton-block--tall'
              : block === 'chart'
                ? ' dashboard-skeleton-block--chart'
                : ''
          }`}
        />
      ) : null}
    </div>
  )
}

export default DashboardSectionCardSkeleton
